import React, { useState } from 'react';

const ChatPanel = ({ onSubmit, searchQuery, onClearFilter, isFiltered }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSubmit(message.trim());
      setMessage('');
    }
  };

  const handleClearFilter = () => {
    onClearFilter();
    setMessage('');
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMessage(value);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-2xl px-4">
      {/* Search Results Filter */}
      {isFiltered && (
        <div className="mb-4 p-3 bg-blue-900/30 border border-blue-700/50 rounded-xl">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <span className="text-white text-sm font-medium">
                Search: "{searchQuery}"
              </span>
            </div>
            <button 
              className="bg-red-600 hover:bg-red-500 text-white text-xs px-3 py-1.5 rounded-full transition-colors duration-200"
              onClick={handleClearFilter}
            >
              Clear Filter
            </button>
          </div>
        </div>
      )}
      
      <div className="relative">

        <div className="relative p-4 rounded-xl bg-zinc-100/75">
          <form onSubmit={handleSubmit} data-testid="chat-form">
            <input
              type="text"
              value={message}
              onChange={handleInputChange}
              placeholder="Search your mementos..."
              autoComplete="off"
              className="p-2 w-full peer focus:outline-none bg-transparent text-gray-800 placeholder-zinc-500"
            />
            
            <div className="absolute inset-0 rounded-xl border transition-colors pointer-events-none border-zinc-400 peer-focus:border-brand-500">
            </div>
            
            <div className="flex justify-end items-center">
              <button
                type="submit"
                disabled={!message.trim()}
                className="flex justify-center items-center p-2 text-white bg-brand-500 hover:bg-brand-600 rounded-full transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChatPanel;
